import { Button } from 'antd';
import { AlignLeftOutlined } from '@ant-design/icons';
import { FormattedMessage } from 'react-intl';

const AlignLeft = ({ editor, showLabel = false }) => {
  return (
    <Button
      className={`editor-toolbar-btn-container ${editor.isActive({ textAlign: 'left' }) ? '!bg-slate-100 text-black' : '!bg-transparent'}`}
      icon={<AlignLeftOutlined className="text-gray-800 text-xs" />}
      onClick={() => editor.chain().focus().setTextAlign('left').run()}
      size="small"
      type="text"
    >
      {showLabel && (
        <div className="editor-toolbar-btn-label">
          <FormattedMessage id="ALIGN_LEFT" defaultMessage="Align left" />
        </div>
      )}
    </Button>
  );
};

export default AlignLeft;
